import React, { useState, useMemo } from 'react';
import { Drawer, Input, Collapse, Row, Col, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { NODE_CATEGORIES, NODE_TYPE_LIST } from '../constants/nodeTypes';


const { Panel } = Collapse;

const AddNodeDrawer = ({ open, onClose, onSelect, hasTrigger }) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return NODE_TYPE_LIST.filter(
      (n) =>
        (!hasTrigger || n.category !== 'triggers') &&
        (!q ||
          n.label.toLowerCase().includes(q) ||
          n.type.toLowerCase().includes(q))
    );
  }, [search, hasTrigger]);

  const categories = useMemo(() => {
    return NODE_CATEGORIES.filter((cat) => !hasTrigger || cat.key !== 'triggers');
  }, [hasTrigger]);

  const drawerTitle = (
    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
      <span>Add step</span>
      <Input
        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
        placeholder="Search blocks..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        allowClear
        style={{ width: 220 }}
      />
    </Space>
  );

  return (
    <Drawer
      title={drawerTitle}
      placement="right"
      width={800}
      open={open}
      onClose={onClose}
      mask={true}
      destroyOnClose
      styles={{ body: { padding: '16px 12px' } }}
    >
      <Collapse defaultActiveKey={categories.map((c) => c.key)}>
        {categories.map((cat) => {
          const items = filtered.filter((n) => n.category === cat.key);
          if (!items.length) return null;
          return (
            <Panel header={cat.label} key={cat.key}>
              <Row gutter={[10, 10]}>
                {items.map((n) => {
                  const Icon = n.icon;
                  return (
                    <Col key={n.type} span={8}>
                      <div
                        role="button"
                        tabIndex={0}
                        onClick={() => onSelect?.(n.type)}
                        onKeyDown={(e) => e.key === 'Enter' && onSelect?.(n.type)}
                        className="add-node-item"
                        style={{
                          height: '100%',
                          padding: '10px 12px',
                          border: '1px solid #f0f0f0',
                          borderRadius: 8,
                          cursor: 'pointer',
                          borderLeft: `4px solid ${n.color}`,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 4,
                          transition: 'all 0.2s ease-in-out',
                        }}
                      >
                        <strong style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
                          {Icon && <Icon style={{ color: n.color, flexShrink: 0 }} />}
                          {n.label}
                        </strong>
                        <div style={{ fontSize: 11, color: '#8c8c8c', lineHeight: '1.4' }}>{n.subtitle}</div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Panel>
          );
        })}
      </Collapse>
    </Drawer>
  );
};

export default AddNodeDrawer;
